import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {CryptoService} from './crypto.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment, isODM} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SoftwareService {

  event: number;
  status: number;
  startDate: number;
  endDate: number;
  constructor(
    private http: HttpClient,
    private cryptoService: CryptoService) { }

  ReadSoftwareVersionData(params): Observable <any> {
    // params = {...params, otp: params.otp + this.cryptoService.hashHmacSha512ForContent(params)};
    return this.http.post<any>(`${environment.apiIotUrl}/software/version/read`, params);
  }
}
